
import React, { useState } from 'react'
import { FaPhoneAlt, FaEnvelope, FaArrowRight, FaPaperPlane } from 'react-icons/fa'

import Layout from '../../components/layout'
import Map from '../../components/map';
import MessageForm from '../../components/MessageForm';
import Modal from '../../components/Modal';
import SectionHeading from '../../components/SectionHeading'
import { OFFICES } from '../../constants/site'

import avatar_kg from '../../assets/employees/kalle-profil.jpg'

export default function ContactPage() {
  const [formOpen, setFormOpen] = useState(false)

  return (
    <Layout>
      <div id="contact" className="section grid gap-12 lg:grid-cols-2 lg:gap-16">
        <div className="flex flex-col gap-6 sm:gap-10">
          <SectionHeading eyebrow="Kontakt" title="Modernisera och säkra ert nätverk med oss">
            <p>Kontakta oss för mer information!</p>
          </SectionHeading>

          <div className="card flex items-center gap-5 p-5">
            <img className="h-16 w-16 rounded-full object-cover" src={avatar_kg} alt="Kalle Gustafsson" />
            <div className="flex min-w-0 flex-col gap-1">
              <span className="font-semibold">Kalle Gustafsson</span>
              <span className="text-sm text-slate-500 dark:text-slate-400">Business Development Manager</span>
              <div className="mt-1 flex flex-wrap gap-x-5 gap-y-1 text-sm">
                <a href="tel:0726021606" className="inline-flex items-center gap-2 text-sky-500 hover:text-sky-400">
                  <FaPhoneAlt size={12} /> 072-602 16 06
                </a>
                <a href="mailto:kalle.gustafsson@acebit.se" className="inline-flex items-center gap-2 text-sky-500 hover:text-sky-400">
                  <FaEnvelope size={12} /> kalle.gustafsson@acebit.se
                </a>
              </div>
            </div>
          </div>

          {/* På mobil öppnas formuläret som modal istället */}
          <button type="button" onClick={() => setFormOpen(true)} className="btn-primary w-full lg:hidden">
            <FaPaperPlane size={12} /> Skicka ett meddelande
          </button>

          <div className="flex items-center gap-6">
            <Map className="hidden h-80 shrink-0 sm:inline-block" />
            <ul className="grid w-full grid-cols-2 gap-4 sm:flex sm:w-auto sm:flex-col sm:gap-5">
              {OFFICES.map((office) => (
                <li key={office.name} className="flex flex-col text-sm">
                  <span className="text-base font-semibold">{office.name}</span>
                  <span className="text-slate-500 dark:text-slate-400">{office.street}, {office.zip}</span>
                  <a href={office.maps} target="_blank" rel="noopener noreferrer" className="mt-1 inline-flex items-center gap-1.5 text-sky-500 hover:text-sky-400">
                    Hitta hit <FaArrowRight size={10} />
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="hidden lg:block lg:pt-8">
          <MessageForm />
        </div>

        {formOpen && (
          <Modal onClose={() => setFormOpen(false)}>
            <MessageForm onClose={() => setFormOpen(false)} />
          </Modal>
        )}
      </div>
    </Layout>
  )
}
